module.exports = __webpack_public_path__ + "static/_02-d8e1653f7937548a2e1fd1a4f9df593a.png";